<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 16:39:04
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-06 14:30:15
-->
<template>
	<div>
		<el-select v-bind="$attrs" v-model="userId" clearable filterable :placeholder="placeholder" @change="change">
			<el-option :label="item.name" :value="item.userId" v-for="(item, index) in optionList" :key="index">
				<div class="flex flex-align-center">
					<span class="mr-8">{{ item.name }}</span>
					<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
					<el-tag v-else-if="item.use_status == 2" type="danger" size="mini">账号已停用</el-tag>
				</div>
			</el-option>
		</el-select>
	</div>
</template>
<script>
import { drRoleType } from '@/utils/dataMap';
import { getDrSelectList } from '@/api/teamManage';
export default {
	name: 'DrPartnerSelect',
	props: {
		value: [String, Number, Array],
		placeholder: {
			type: String,
			default: `请选择 / 搜索${drRoleType.name}`,
		},
		customData: {
			type: Array,
			default: _ => [],
		},
	},
	watch: {
		value(val) {
			this.userId = val;
		},
	},
	data() {
		return {
			userId: this.value,
			optionList: [],
		};
	},
	mounted() {
		this.getCateList();
	},
	methods: {
		change(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCateList() {
			//达人商务
			const { code, data } = await getDrSelectList();
			if (code === 0) {
				let list = [...this.customData, ...data];
				// 将数组分成三个部分
				const notUseStatus2AndNotDeleted = list.filter(item => item.use_status != 2 && !item.deleted);
				const useStatus2 = list.filter(item => item.use_status == 2);
				const deleted = list.filter(item => item.deleted);
				// 合并三个部分
				this.optionList = [...notUseStatus2AndNotDeleted, ...useStatus2, ...deleted];
			}
		},
		reset() {
			this.userId = [];
		},
	},
};
</script>
